export default __webpack_public_path__ + "static/media/telemarketinghelp-detail-mobileE.0ab09673.png";